export enum ActionTypes {
  // the 'GetEmailApiPlans' action is for loading state
  GetEmailApiPlans = 'getEmailApiPlans',
  GetEmailApiPlansSuccess = 'getEmailApiPlans.success',
  GetEmailApiPlansFailure = 'getEmailApiPlans.failure',
}
